import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject, combineLatest, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { LeftMenuService } from 'src/app/layouts/left-menu/left-menu.service';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { LocaleService } from 'src/app/shared/service/locale.service';
import { LocalStorageService } from 'src/app/shared/service/localstorage.service';
import { PopupService } from 'src/app/shared/service/popup.service';
import { DailyRacesService } from '../../daily-races/daily-races.service';
import { FriendService } from '../../friend/friend.service';
import { InviteFriendsComponent } from '../../friend/recommend/dialog/invite-friends/invite-friends.component';
import { ActivityService } from '../activity.service';
import { BetFreeJackpotService } from '../bet-free-jackpot/bet-free-jackpot.service';

interface ActivitiesFormatStyle {
  value: {
    longStyle: boolean;
    sort: number;
    action: string;
    fullStyle: {
      className: string;
      text: string;
      secondText: string;
      image: string;
      imageClassName: string;
      imageTwo: string;
      imageTwoClassName: string;
    };
  };
}

interface RailActivitiesFormatStyle {
  value: {
    sort: number;
    action: string;
    railStyle: {
      hoverShow: boolean;
      className: string;
      image: string;
      imageClassName: string;
      imageTwo: string;
      imageTwoClassName: string;
      hoverItem?: {
        className: string;
        image: string;
        imageClassName: string;
        imageTwo: string;
        imageTwoClassName: string;
        action: string;
      } | null;
    };
  };
}

type ActivitiesKeys = 'daily' | 'freeGuess' | 'wheel' | 'tournament';
@UntilDestroy()
@Component({
  selector: 'app-left-menu-activity-bar',
  templateUrl: './left-menu-activity-bar.component.html',
  styleUrls: ['./left-menu-activity-bar.component.scss'],
})
export class LeftMenuActivityBarComponent implements OnInit {
  constructor(
    private betFreeJackpotService: BetFreeJackpotService,
    private dailyRacesService: DailyRacesService,
    public appService: AppService,
    private popup: PopupService,
    private router: Router,
    private layout: LayoutService,
    public leftMenuService: LeftMenuService,
    private friendService: FriendService,
    public activityService: ActivityService,
    private localeService: LocaleService,
    private localStorageService: LocalStorageService,
  ) {}

  ngOnInit() {
    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe(v => (this.isH5 = v));
    this.onLeftMenuActivities();
  }

  @Output() afterClick: EventEmitter<any> = new EventEmitter();

  @Input() showRail: boolean = false;

  @Input() showFully: boolean = true;

  @Input() showInviteCodeModel: boolean = true;

  isLogined: boolean = !!this.localStorageService.loginToken;

  isH5!: boolean;

  /** 轨道菜单栏 新增 活动转盘 wheel */
  positions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'top',
    },
  ];

  hasActivities: boolean = false;

  /** 活动样式 分配 */
  activitiesFormatStyle = {
    daily: {
      longStyle: false,
      sort: 0,
      action: 'dailyRaces',
      fullStyle: {
        className: 'full-daily-races',
        text: this.localeService.getValue('task'),
        secondText: this.localeService.getValue('unlocked'),
        image: 'assets/images/activity/left-bar/rail-activity.png',
        imageClassName: 'common-img',
        imageTwo: '',
        imageTwoClassName: '',
      },
    },
    wheel: {
      longStyle: false,
      sort: 1,
      action: 'wheel',
      fullStyle: {
        className: 'full-wheel',
        text: this.localeService.getValue('spin'),
        secondText: '',
        image: 'assets/images/activity/left-bar/wheel.png',
        imageClassName: 'full-wheel-img',
        imageTwo: 'assets/images/activity/left-bar/needle.png',
        imageTwoClassName: 'full-needle',
      },
    },
    tournament: {
      longStyle: false,
      sort: 2,
      action: 'tournament',
      fullStyle: {
        className: 'full-tournament',
        text: this.localeService.getValue('tournament'),
        secondText: '',
        image: 'assets/images/activity/left-bar/tournament.png',
        imageClassName: 'common-img',
        imageTwo: '',
        imageTwoClassName: '',
      },
    },
    freeGuess: {
      longStyle: false,
      sort: 3,
      action: 'jackpot',
      fullStyle: {
        className: 'full-guess',
        secondClassName: 'span-second-line',
        text: this.localeService.getValue('free_guess'),
        secondText: '',
        image: 'assets/images/activity/left-bar/guess.png',
        imageClassName: 'bonus__bg',
        imageTwo: '',
        imageTwoClassName: '',
      },
    },
  };

  railActivitiesFormatStyle = {
    daily: {
      sort: 0,
      action: 'dailyRaces',
      railStyle: {
        hoverShow: false,
        className: 'rail-daily-races',
        image: 'assets/images/activity/left-bar/rail-activity.png',
        imageClassName: 'rail-daily-races-img',
        imageTwo: '',
        imageTwoClassName: '',
        hoverItem: {
          open: true,
          action: 'wheel',
          className: 'rail-wheel',
          image: 'assets/images/activity/left-bar/wheel.png',
          imageClassName: 'rail-wheel',
          imageTwo: 'assets/images/activity/left-bar/needle.png',
          imageTwoClassName: 'rail-needle',
        },
      },
    },
    wheel: {
      sort: 1,
      action: 'wheel',
      railStyle: {
        hoverShow: false,
        className: 'rail-wheel',
        image: 'assets/images/activity/left-bar/wheel.png',
        imageClassName: 'rail-wheel',
        imageTwo: 'assets/images/activity/left-bar/needle.png',
        imageTwoClassName: 'rail-needle',
        hoverItem: null,
      },
    },
    tournament: {
      sort: 2,
      action: 'tournament',
      railStyle: {
        hoverShow: false,
        className: 'rail-tournament',
        image: 'assets/images/activity/left-bar/tournament.png',
        imageClassName: 'rail-tournament-img',
        imageTwo: '',
        imageTwoClassName: '',
        hoverItem: null,
      },
    },
    freeGuess: {
      sort: 3,
      action: 'jackpot',
      railStyle: {
        imageTwo: '',
        imageTwoClassName: '',
        hoverShow: false,
        className: 'rail-guess',
        image: 'assets/images/activity/left-bar/guess.png',
        imageClassName: 'rail-guess-img',
        hoverItem: null,
      },
    },
  };
  activitiesLoading = false;

  onLeftMenuActivities() {
    this.activitiesLoading = true;
    combineLatest([
      this.dailyRacesService.getDailyTitles(),
      this.activityService.getturntableinformation(),
      this.activityService.getRecentActivity(),
      this.activityService.getTournamentList(),
    ]).subscribe(([daily, wheel, freeGuess, tournament]) => {
      const hasList =
        (tournament.endList && Number(tournament.endList?.records?.length || 0) > 0) ||
        (tournament.perList && Number(tournament.perList?.records?.length || 0) > 0) ||
        (tournament.startList && Number(tournament.startList?.records?.length || 0) > 0);

      if (!(Number(daily?.title?.length || 0) > 0)) {
        delete this.activitiesFormatStyle['daily' as ActivitiesKeys];
        delete this.railActivitiesFormatStyle['daily' as ActivitiesKeys];
      } else {
        delete this.railActivitiesFormatStyle['wheel' as ActivitiesKeys];
        this.hasActivities = true;
      }

      if (!freeGuess?.data?.haveRunningActivity) {
        delete this.activitiesFormatStyle['freeGuess' as ActivitiesKeys];
        delete this.railActivitiesFormatStyle['freeGuess' as ActivitiesKeys];
      } else {
        this.hasActivities = true;
      }

      if (!wheel?.data) {
        delete this.activitiesFormatStyle['wheel' as ActivitiesKeys];
        if (this.railActivitiesFormatStyle?.daily) {
          this.railActivitiesFormatStyle.daily.railStyle.hoverItem.open = false;
        } else {
          delete this.railActivitiesFormatStyle['wheel' as ActivitiesKeys];
        }
      } else {
        this.hasActivities = true;
      }

      if (!hasList) {
        delete this.activitiesFormatStyle['tournament' as ActivitiesKeys];
        delete this.railActivitiesFormatStyle['tournament' as ActivitiesKeys];
      } else {
        this.hasActivities = true;
      }

      const currentLeng = Object.values(this.activitiesFormatStyle).length;

      Object.keys(this.activitiesFormatStyle).forEach((activity, index) => {
        const currentActivity = this.activitiesFormatStyle[activity as ActivitiesKeys];
        switch (currentLeng) {
          case 1:
            currentActivity.longStyle = true;
            break;
          case 3:
            currentActivity.longStyle = index === 0;
            break;
          case 4:
            currentActivity.longStyle = index === 0 || index === 3;
            break;
          default:
            currentActivity.longStyle = false;
            break;
        }
      });
      this.activitiesLoading = false;
    });
  }

  sortActivities(
    a: ActivitiesFormatStyle | RailActivitiesFormatStyle,
    b: ActivitiesFormatStyle | RailActivitiesFormatStyle,
  ) {
    return a.value.sort - b.value.sort;
  }

  /** 子菜单 订阅 */
  onShowSubItem$: Subject<boolean> = new Subject();

  /** 展示wheel */
  isShowWheal: boolean = false;

  /** 是否显示好友推荐链接弹窗 */
  isShowInviteCodeModel!: boolean;

  /** 获取当前路由 */
  get getUrl(): string {
    return this.router.url.split('/').slice(2).join('/');
  }

  onShowSubItem(key: string) {
    const styleKey = key as ActivitiesKeys;
    this.onCloseSubItem(0, key);
    this.onShowSubItem$.next(true);
    if (this.railActivitiesFormatStyle[styleKey]?.railStyle.hoverItem?.open) {
      this.railActivitiesFormatStyle[styleKey].railStyle.hoverShow = true;
    }
  }

  onCloseSubItem(time: number, key: string) {
    const styleKey = key as ActivitiesKeys;
    if (time > 0) {
      timer(time)
        .pipe(takeUntil(this.onShowSubItem$))
        .subscribe(_ => {
          this.railActivitiesFormatStyle[styleKey].railStyle.hoverShow = false;
        });
    } else {
      this.railActivitiesFormatStyle[styleKey].railStyle.hoverShow = false;
    }
  }

  click(type?: string) {
    switch (type) {
      case 'dailyRaces':
        if (this.isLogined) {
          this.dailyRacesService.openPopup();
        } else {
          this.appService.openLazyComponentDialog('LoginRegisterComponent', { type: 'login' });
        }
        break;
      case 'jackpot':
        this.betFreeJackpotService.getActivitiesIs();
        break;
      case 'wheel':
        this.router.navigate([], {
          queryParams: {
            modal: 'wheel',
          },
        });
        //break; 这里产品要点击后不关闭弹窗，等大转盘上线后再调整回来
        return;
      case 'tournament':
        this.router.navigate([this.appService.languageCode, 'activity', 'tournament']);
        break;
      case 'invite':
        this.openInvitePop();
        break;
      default:
        break;
    }
    this.afterClick.emit();
  }

  openInvitePop() {
    if (this.showInviteCodeModel) {
      this.popup.open(InviteFriendsComponent, {
        inAnimation: this.isH5 ? 'fadeInUp' : undefined,
        outAnimation: this.isH5 ? 'fadeOutDown' : undefined,
        position: this.isH5 ? { bottom: '0px' } : undefined,
        speed: 'faster',
        autoFocus: false,
        panelClass: 'invite-friend-popup-page',
      });
    } else {
      this.router.navigateByUrl(`${this.appService.languageCode}/referral/home`);
      this.layout.leftMenuState$.next(false);
    }
  }

  /**
   * 已有推荐好友的跳转到推荐好友主页，没有的弹窗
   */
  getReferralLinkRoute() {
    this.friendService.getReferralInfo();
    this.friendService.referralInfo$.pipe(untilDestroyed(this)).subscribe(x => {
      this.isShowInviteCodeModel = !x?.totalReferrals;
    });
  }
}
